import Enumerable from "linq";
import { Point, Rectangle, Vector } from "../../../../domain/drawing";
import { DragKinds } from "../../DragKinds";
import { AbstractTransformer } from "./AbstractTransformer";

export abstract class AbstractStandardTransformer extends AbstractTransformer {
  transformRectangle(source: Rectangle, pointer: Point, kind: DragKinds): Rectangle {
    return Enumerable.from([
      this.isResizingToTop(kind) ? s => this.resizeToTop(s, pointer) : s => s,
      this.isResizingToLeft(kind) ? s => this.resizeToLeft(s, pointer) : s => s,
      this.isResizingToBottom(kind) ? s => this.resizeToBottom(s, pointer) : s => s,
      this.isResizingToRight(kind) ? s => this.resizeToRight(s, pointer) : s => s,
    ] as ((s: Rectangle) => Rectangle)[])
    .aggregate(source, (s, t) => t(s));
  }

  protected abstract resizeToTop(source: Rectangle, pointer: Point): Rectangle;
  protected abstract resizeToLeft(source: Rectangle, pointer: Point): Rectangle;
  protected abstract resizeToRight(source: Rectangle, pointer: Point): Rectangle;
  protected abstract resizeToBottom(source: Rectangle, pointer: Point): Rectangle;

  transformVector(source: Vector, pointer: Point, kind: DragKinds): Vector {
    if (this.isMovingFrom(kind)) {
      return this.moveFrom(source, pointer);
    }
    if (this.isMovingTo(kind)) {
      return this.moveTo(source, pointer);
    }
  }

  protected abstract moveFrom(source: Vector, pointer: Point): Vector;
  protected abstract moveTo(source: Vector, pointer: Point): Vector;
}
